export const SendStep = {
  CONTACT: 'contact',
  DETAILS: 'details',
  REVIEW: 'review',
  COMPLETE: 'complete',
  APPROVAL: 'approval',
} as const

export type SendStep = (typeof SendStep)[keyof typeof SendStep]
